import { fetchProductListItems } from "./service";
import { fetchPeopleListItemsV2 } from "../Search/people/service";

const Model = {
    namespace: 'list',
    state: {
        productLists: {},
        peopleLists: {},
        selectedRows: []
    },
    effects: {
        *fetchProductListItems({ payload, callback }: any, { call, put }: any) {
            let response: Promise<any> = yield call(fetchProductListItems, payload.id);
            response = (response as any).map((item: any) => {
                return {
                    item_id: item?.id || null,
                    id: item?.product?.id || null,
                    product_id: item?.product?.id || null,
                    name: item?.product?.name || '',
                    packaging_type: item?.product?.packaging_type || '',
                    manufacturer_details: item?.product?.manufacturer_details || '',
                    country_of_origin: item?.product?.country_of_origin || '',
                    category: item?.product?.category || '',
                    marketed_by: item?.product?.marketer?.name || '',
                    marketer_employee_count: item?.product?.marketer?.team_size || '',
                    countries_of_sale: item?.product?.countries_of_sale?.map((c: any) => c?.name || '').join(", ") || '',
                }
            })
            yield put({
                type: 'setProductListItems',
                payload: {
                    id: payload.id,
                    items: response
                }
            });

            if (callback) {
                callback(response);
            }
        },
        *fetchPeopleListItemsV2({ payload, callback }: any, { call, put }: any) {
            try {
                const response: any[] = yield call(fetchPeopleListItemsV2, payload.listId);
                
                yield put({
                    type: 'setPeopleListItems',
                    payload: {
                        id: payload.listId,
                        items: response
                    }
                });

                if (callback) {
                    callback(response);
                }
            } catch (error) {
                console.error('Error fetching people list items:', error);
                if (callback) {
                    callback([]);
                }
            }
        }
    },
    reducers: {
        setProductListItems(state: any, { payload }: any) {
            return {
                ...state,
                productLists: {
                    ...state.productLists,
                    [payload.id]: payload.items
                }
            };
        },
        setPeopleListItems(state: any, { payload }: any) {
            return {
                ...state,
                peopleLists: {
                    ...state.peopleLists,
                    [payload.id]: payload.items
                }
            };
        },
        initSelectedRows(state: any) {
            return {
                ...state,
                selectedRows: []
            };
        },
        addToSelectedRows(state: any, { payload }: any) {
            if (!state.selectedRows.includes(payload)) {
                return {
                    ...state,
                    selectedRows: [...state.selectedRows, payload]
                };
            }
            return state;
        },
        removeFromSelectedRows(state: any, { payload }: any) {
            return {
                ...state,
                selectedRows: state.selectedRows.filter((id: any) => id !== payload)
            };
        },
        clearSelectedRows(state: any) {
            return {
                ...state,
                selectedRows: []
            };
        }
    }
}

export default Model;